// src/Collaboration.js
import React, { useState } from 'react';
import './App.css';

const categories = ['Companies', 'Fitness & Nutrition Brands', 'Top Gyms'];

const partnersData = {
  Companies: [
    { name: 'KSB Ltd.', logo: 'img/comp1.png' },
    { name: 'Persistent Systems', logo: 'img/comp2.png'},
    { name: 'PubMatic', logo: 'img/comp3.png' },
    { name: 'Skoda VW Group', logo: 'img/comp4.png' },
    { name: 'Rebel Foods', logo: 'img/comp5.png' },
     { name: 'Mealawe', logo: 'img/comp6.png' },
    { name: 'Bank of Maharashtra', logo: 'img/comp7.png' },
    { name: 'Singulr AI Technologies', logo: 'img/comp8.png' },
    { name: 'Foton Motors', logo: 'img/comp9.png' },
    { name: 'Filtra Consultants and Eng.', logo: 'img/comp10.png' },
     { name: 'E-way Corp Technology', logo: 'img/comp11.png' },
      { name: 'SmartQ', logo: 'img/comp12.png' },
       { name: 'AAM Company', logo: 'img/comp13.png' },
        { name: 'Neeyamo', logo: 'img/comp14.png' },
         { name: 'Icertis', logo: 'img/comp15.png' },
  ],
  'Fitness & Nutrition Brands': [
     { name: 'FITTR', logo: 'img/fitn1.png' },
    { name: 'Decathlon', logo: 'img/fitn2.png' },
    { name: 'OMFIT', logo: 'img/fitn3.png' },
    { name: 'PFC Club Fitness', logo: 'img/fitn4.png' },
    { name: 'Aquatein', logo: 'img/fitn5.png' },
    { name: 'The Healthy Binge', logo: 'img/fitn6.png' },
{ name: 'SuperYou', logo: 'img/fitn7.png' },
    { name: 'The Whole Truth', logo: 'img/fitn8.png' },
    { name: 'CDMK Fitness', logo: 'img/fitn9.png' },
  ],
  'Top Gyms': [
     { name: 'MultiFit', logo: 'img/gym1.png' },
    { name: 'Gold’s Gym', logo: 'img/gym2.png' },
    { name: 'Urbounce Gym', logo: 'img/gym3.png' },
    { name: 'Gagan Narang Sports Promot...', logo: 'img/gym4.png' },
    { name: 'Zone360', logo: 'img/gym5.png' },
    { name: 'PTown MMA', logo: 'img/gym6.png' },
    { name: 'Alpha Fit', logo: 'img/gym7.png' },
    { name: '1Repp', logo: 'img/gym8.png' },
    { name: 'F2 Fitness', logo: 'img/gym9.png' },
    { name: 'Fitness Arena', logo: 'img/gym10.png' },
    { name: 'Passion Fitness', logo: 'img/gym11.png' },
    { name: 'The Kiro Fitness', logo: 'img/gym12.png' },
  ],
};

const Collaboration = () => {
  const [selectedCategory, setSelectedCategory] = useState('Companies');

  return (
    <div>
       <section className="hero">
      <img src="img/blogleft.png" className="vectorall-left desktopvector" alt="left vector" />
  <img src="img/m2.png" className="vectorall-left mobilevector" alt="left vector" />
  
  <div className="hero-content">
  <h1 className="headline">
  <span style={{ color: '#2F2F2F' }}>Our Partners In Health</span>
</h1>
<p className='subehad'>  There’s no such thing as doing it alone, which is why we have collaborated with leading brands</p>

  </div>


</section>
       <div className="collaboration-page">
      <div className="category-tabs">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`tab-button ${selectedCategory === cat ? 'active' : ''}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="partners-grid">
        {partnersData[selectedCategory].map((partner, idx) => (
          <div className="partner-card" key={idx}>
           <div className="partnerimgdiv" > <img src={partner.logo} alt={partner.name} /></div>
            <p>{partner.name}</p>
          </div>
        ))}
        {partnersData[selectedCategory].length === 0 && (
          <p style={{ textAlign: 'center', marginTop: '40px' }}>No partners listed yet.</p>
        )}
      </div>
      </div>
    </div>
  );
};

export default Collaboration;
